import FormProps from "data/forms"
import RejectDocumentFormFields from "./types";
import TextAreaInput from "Components/molecule/inputs/textarea-inpuit";
import PrimaryButton from "Components/atoms/buttons/primary-button";
import SecondaryButton from "Components/atoms/buttons/secondary-button";


const RejectDocumentForm = ({
    handleBlur,
    handleChange,
    handleSubmit,
    handleCancel,
    values,
    errors,
    touched,
    isSubmitting,
    isValid
}: FormProps<RejectDocumentFormFields>) => {

    return <div className="form-container">
        <div>
            <h6>Please give a reason for rejecting document.</h6>
        </div>
        <div className="input-grid">
            <TextAreaInput
                message={touched.reason ? errors.reason : undefined}
                onBlur={handleBlur}
                name={"reason"}
                error={!!touched.reason && !!errors.reason}
                required
                className="text-area-input"
                value={values.reason}
                key={'reason'}
                label={"Reason"}
                placeholder={"Why are you rejecting the document"}
                max={3000}
                onChange={handleChange}
            />
        </div>
        <div className="button-container">
            <PrimaryButton
                type='submit'
                onClick={() => handleSubmit()}
                disabled={isSubmitting || !isValid}
            >
                {isSubmitting ? "Rejecting...." : "Reject"}
            </PrimaryButton>
            {
                handleCancel &&
                <SecondaryButton
                    disabled={isSubmitting}
                    onClick={() => handleCancel()}
                >
                    Cancel
                </SecondaryButton>
            }
        </div>
    </div>
}


export default RejectDocumentForm
